export default __webpack_public_path__ + "static/media/CNo.89-6.68208902.jpg";